import { getHttpClient } from 'src/http-client';

const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export async function getAutomationRuleByIdService(organizationName: string, projectId: string, id: string) {
	const httpClient = getHttpClient();
	const response = await httpClient.get(`${apiUrl}/automations/${organizationName}/${projectId}/${id}`, {
		headers: {
			'Content-Type': 'application/json'
		}
	});

	return response;
}